





























































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import CrearCliente from './CrearCliente.vue';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    MantenedorGrid,
    CrearCliente,
  },
})
export default class DetalleClientes extends ComponenteBase {
  @Prop({ required: true }) clientes: any;

  filtro: string = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades =
    Funcionalidades.TablaSolicitudBajaClientesCrear;
  usuario = JSON.parse(localStorage.getItem('user')).id;
  modalCrear: boolean = false;

  mounted() {
    this.initialize();
  }

  async crearDato(numero: number): Promise<Boolean> {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      {
        numero: numero,
        solicitudes: this.ordesList,
      },
      'conecta_solicitud_baja_cliente/crear_detalle'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al crar las solicitudes', {
          timeout: 3000,
        });
        return false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return false;
      });
  }

  exportarExcel() {
    if (this.ordesList.length == 0) {
      this.$snotify.error('Por favor, cree al menos una solicitud', {
        timeout: 3000,
      });
      return;
    }
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        'CRM Baja': e.crmBaja,
        'CRM Fecha': moment(e.crmFecha).format('YYYY-MM-DD'),
        Cliente: e.clienteNombre,
        Equipos: e.equipos,
        Perifericos: e.perifericos,
        Autor: e.autor,
        Concepto: e.concepto,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Solicitudes_Creadas_Baja');
    writeFileXLSX(wb, 'Solicitudes_Creadas_Baja.xlsx');
    this.$snotify.success('Excel Exportado con exito', 3000);
  }

  agregarCliente(data: any) {
    this.ordesList.push(data);
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.enviarDatos();
  }

  cerrarModal() {
    this.modalCrear = false;
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: true,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: true,
  };

  accionImportar: PermisoAccion = {
    accionCodigo: 50,
    visible: true,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionExportar,
    this.accionImportar,
  ];

  // Globales

  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY-MM-DD');
  }

  crmFecha: any;
  rut: any;
  cliente: any;
  equipos: any;
  perifericos: any;
  autor: any;
  concepto: any;
  enviarDatos() {
    this.$emit('informacion', this.ordesList);
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'CRM Baja',
        field: 'crmBaja',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'CRM Fecha',
        field: 'crmFecha',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Cliente',
        field: 'clienteNombre',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Equipos',
        field: 'equipos',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Periféricos',
        field: 'perifericos',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Autor',
        field: 'autor',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Concepto',
        field: 'concepto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        sortable: false,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 30, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('YYYY-MM-DD');
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (
        this.funcionalidad === Funcionalidades.TablaSolicitudBajaClientesCrear
      ) {
        if (data.action === Accion.Eliminar) {
          this.editedItem = null;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.ordesList.indexOf(
              data.cellRendererParams.data
            );
            this.ordesList.splice(indexDelete, 1);
            this.gridApi.setRowData(this.ordesList);
            this.gridApi.setDomLayout('autoHeight');
            this.enviarDatos();
          }
        }
      }
    });
  }
}
